var render = function render(){
  var _vm$content$orcamento;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('p', [_c('strong', [_vm._v("Passo a passo:")])]), _c('div', {
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('p', [_vm._v("1. Baixe o Modelo: Baixe o modelo disponivel para o preenchimento.")]), _c('p', [_vm._v("2. Preencha o arquivo de acordo com as informações solicitadas.")]), _c('p', [_vm._v("3. Faça upload de arquivos do tipo .xlsx de tamanho máximo de 100 MB.")])]), _c('v-row', {
    staticClass: "align-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('p', [_c('strong', [_vm._v("Planilha Orçamentária:")])]), _c('sigfoco-upload-file', {
    ref: "uploadFileComponent",
    staticClass: "mt-3",
    attrs: {
      "size": 12,
      "maxSize": 100,
      "formats": '.xlsx',
      "label": "Enviar arquivo",
      "resetAfterUpload": true,
      "disabled": _vm.isViewMode
    },
    model: {
      value: _vm.content.anexo,
      callback: function ($$v) {
        _vm.$set(_vm.content, "anexo", $$v);
      },
      expression: "content.anexo"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }), _c('v-col', {
    staticClass: "align-center mt-10",
    attrs: {
      "cols": "5"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-end"
  }, [_c('p', {
    staticClass: "my-7 mr-2"
  }, [_c('strong', [_vm._v("Baixar modelo:")])]), _c('v-btn', {
    staticClass: "ml-2 mt-4",
    attrs: {
      "color": "primary",
      "rounded": ""
    },
    on: {
      "click": _vm.downloadModelo
    }
  }, [_c('v-icon', [_vm._v("mdi-download")])], 1)], 1)])], 1)], 1), _c('v-data-table', {
    key: (_vm$content$orcamento = _vm.content.orcamentos) === null || _vm$content$orcamento === void 0 ? void 0 : _vm$content$orcamento.length,
    staticClass: "mt-5",
    attrs: {
      "dense": "",
      "headers": _vm.headers,
      "items": _vm.content.orcamentos,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.nomeArquivo`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.nomeArquivo) + " ")];
      }
    }, {
      key: `item.tipo`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.tipo.toUpperCase()) + " ")];
      }
    }, {
      key: `item.tamanho`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.tamanho) + " ")];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref4) {
        var item = _ref4.item,
          index = _ref4.index;
        return [_c('div', {
          key: index
        }, [_c('sigfoco-tooltip', {
          attrs: {
            "text": 'Baixar',
            "icon": 'mdi-download',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.baixarOrcamento(item, index);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": 'Excluir',
            "icon": 'mdi-delete',
            "small": true,
            "disabled": _vm.isViewMode
          },
          on: {
            "click": function ($event) {
              return _vm.excluirOrcamento(item, index);
            }
          }
        })], 1)];
      }
    }], null, true)
  }), _vm.qtdAjustes >= 3 && !_vm.isViewMode ? _c('div', {
    staticClass: "alert-message d-flex align-center mt-4"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("mdi-alert-circle")]), _c('span', [_vm._v("Esta Solicitação de Formação já sofreu três ajustes. Não é possível realizar mais alterações.")])], 1) : _vm._e(), _vm.situacaoParaExibirComentario ? _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Comentário",
      "maxlength": "400",
      "counter": "400",
      "dense": "",
      "outlined": "",
      "rows": "6",
      "disabled": _vm.isViewMode || _vm.qtdAjustes >= 3 || _vm.isReenviar()
    },
    model: {
      value: _vm.content.comentario,
      callback: function ($$v) {
        _vm.$set(_vm.content, "comentario", $$v);
      },
      expression: "content.comentario"
    }
  })], 1)], 1) : _vm._e(), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '##########.######/####-##',
      expression: "'##########.######/####-##'"
    }],
    attrs: {
      "label": "Inserir Número de Processo SEI",
      "maxlength": "25",
      "counter": "25",
      "dense": "",
      "outlined": "",
      "rules": [function (v) {
        return _vm.validacaoSei(v);
      }],
      "disabled": _vm.isViewMode || !_vm.situacaoEmConsolidacao
    },
    model: {
      value: _vm.content.numeroSei,
      callback: function ($$v) {
        _vm.$set(_vm.content, "numeroSei", $$v);
      },
      expression: "content.numeroSei"
    }
  })], 1)], 1), !_vm.isFormador ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.content.ultimaAtualizacao))])])])], 1) : _vm._e()], 1), _c('v-row', {
    staticClass: "d-block text-center btn-group"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.voltar
    }
  }, [_vm._v(" Voltar ")]), !_vm.isViewMode && !_vm.situacaoEmRevisao ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.salvar(false);
      }
    }
  }, [_vm._v(" Salvar ")]) : _vm._e(), !_vm.isViewMode && !_vm.situacaoEmRevisao ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary",
      "disabled": !_vm.podeConcluir
    },
    on: {
      "click": function ($event) {
        return _vm.concluirFormacao();
      }
    }
  }, [_vm._v(" Concluir ")]) : _vm._e(), !_vm.isViewMode && _vm.situacaoEmRevisao ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.solicitarCorrecao
    }
  }, [_vm._v(" Solicitar Correção ")]) : _vm._e(), !_vm.isViewMode && _vm.botaoSituacao && _vm.botaoSituacao.visivel ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.botaoSituacao.acao();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.botaoSituacao.label) + " ")]) : _vm._e(), !_vm.isViewMode && !_vm.isReenviar() ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.fechar
    }
  }, [_vm._v(" Fechar ")]) : _vm._e(), !_vm.isViewMode && _vm.isReenviar() ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v(" Cancelar ")]) : _vm._e(), _vm.isViewMode ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v(" Fechar ")]) : _vm._e()], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }